export const triggerPopup = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
  event.preventDefault();
  const { href } = event.target as HTMLAnchorElement;
  window.open(
    href,
    '_blank',
    'toolbar=yes,scrollbars=yes,resizable=yes,top=100,left=175,width=950,height=500'
  );
};
